export default __webpack_public_path__ + "static/media/12-shine.20ad975d.png";